import { mapState, mapActions } from 'vuex';
import exchangeRateDownloadForm from './exchange-rate-download-form/exchange-rate-download-form.vue';
export default {
	data() {
		return {};
	},
	components: {
		'exchange-rate-download-form': exchangeRateDownloadForm
	},
	computed: {
		...mapState('exchangeRate', ['technicalError', 'loading', 'date', 'currenciesForDownload'])
	},
	methods: {
		dateChanged(type, date) {
			this.setDate(date);
			this.getVersions({ type, date });
		},
		...mapActions('exchangeRate', [
			'setDate',
			'getVersions',
			'setVersion',
			'calculate',
			'resetResults',
			'getCurrencies',
			'setTechnicalError',
			'setForeignType',
			'getMessages'
		])
	},
	created() {
		this.getCurrencies();
	}
};
